"use client";

import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const LocationSection = () => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const id = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(id);
  }, [copied]);

  const openInMaps = () => {
    const mapsUrl = "https://maps.app.goo.gl/6C2LVvB414hmtiSU8?g_st=iwb";
    window.open(mapsUrl, '_blank');
  };

  const copyAddress = () => {
    const address = "Avenida España y Cuba, Parada 25, La Mansa, Punta del Este";
    if (navigator.clipboard) {
      navigator.clipboard.writeText(address).then(() => setCopied(true)).catch(() => {});
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6 }}
      className="container-glam section-pad"
    >
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="eyebrow text-vino">Ubicación</p>
          <h2 className="display-title mt-5">Nuestra ubicación</h2>
        </div>
        <p className="max-w-[34ch] font-accent text-lg italic leading-normal">
          Tu centro de belleza en La Mansa.
        </p>
      </div>

      <div className="mt-16 grid gap-px border border-rosa-polvo bg-rosa-polvo md:grid-cols-3">
        <div className="flex flex-col gap-3 bg-crema px-8 py-9">
          <h3 className="eyebrow text-vino">Dirección</h3>
          <p className="text-[17px] leading-[1.6]">
            Avenida España y Cuba<br />Parada 25, La Mansa
          </p>
          <p className="font-accent text-[15px] italic opacity-75">Punta del Este, Uruguay</p>
          <p className="mt-2 border-t border-dorado pt-3 text-sm leading-relaxed opacity-75">
            Referencia: Parada 25 de La Mansa · Esquina de Avenida España y Cuba
          </p>
        </div>

        <div className="flex flex-col gap-3 bg-crema px-8 py-9">
          <h3 className="eyebrow text-vino">Contacto</h3>
          <a href="tel:+59896761805" className="text-[17px] text-espresso transition-colors hover:text-vino">+598 96761805</a>
          <p className="font-accent text-[15px] italic opacity-75">WhatsApp disponible · Reservas por WhatsApp</p>
        </div>

        <div className="flex flex-col gap-3 bg-crema px-8 py-9">
          <h3 className="eyebrow text-vino">Horarios</h3>
          <p className="text-[17px] leading-[1.6]">
            Lun – Vie: 07:00 – 17:30<br />Sáb: 07:00 – 16:00
          </p>
        </div>
      </div>

      <div className="mt-10 flex flex-wrap gap-3.5">
        <button type="button" onClick={openInMaps} className="btn-pill btn-pill--vino">
          Abrir en Google Maps <span className="arrow" aria-hidden="true">→</span>
        </button>
        <button type="button" onClick={copyAddress} className="btn-pill btn-pill--outline-dark" aria-live="polite">
          {copied ? "Dirección copiada ✓" : "Copiar dirección"}
        </button>
      </div>
    </motion.div>
  );
};

export default LocationSection;
